import { OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { FirstErrorPipe } from '@fuse/pipes/first-error/first-error.pipe';
import { DateValidation } from '@validators/date.validation';
import { isEqual } from 'lodash';
import moment from 'moment';
var DialogSchedulingSuggestionsComponent = /** @class */ (function () {
    function DialogSchedulingSuggestionsComponent(data, matDialogRef, firstErrorPipe) {
        this.data = data;
        this.matDialogRef = matDialogRef;
        this.firstErrorPipe = firstErrorPipe;
        this.suggestedLimit = 3;
        this.minDate = moment();
    }
    DialogSchedulingSuggestionsComponent.prototype.ngOnInit = function () {
        this.form = this.data;
        this.scheduleSuggestionsFormArray = this.form.get('scheduleSuggestions');
        this.scheduleSuggestionsFormArrayToSaved = new FormArray([]);
        var scheduleSuggestionsStatus = this.form.get('scheduleSuggestionsStatus') && this.form.get('scheduleSuggestionsStatus').value;
        var hasScheduleSuggestions = this.scheduleSuggestionsFormArray.length > 0;
        var hasScheduleSuggestionsAndScheduleSuggestionsStatus = !!(hasScheduleSuggestions && scheduleSuggestionsStatus);
        var maintenanceStatus = this.form.get('status') && this.form.get('status').value;
        var isOnReallocationDialog = this.form.get('newCompany');
        var isOnReopenDialog = this.form.get('reopenReason');
        var isCorporateAccepted = scheduleSuggestionsStatus === 'corporateAccepted';
        var isSuggestionStopped = scheduleSuggestionsStatus === 'suggestionStopped';
        if (Boolean((scheduleSuggestionsStatus !== 'standardSuggested' || maintenanceStatus === 'canceled') && hasScheduleSuggestionsAndScheduleSuggestionsStatus)
            &&
                (Boolean(maintenanceStatus === 'onNegotiation' || scheduleSuggestionsStatus === 'newScheduleSuggestion') ||
                    Boolean(maintenanceStatus === 'new' &&
                        scheduleSuggestionsStatus === 'corporateSuggested') ||
                    Boolean(maintenanceStatus === 'requested' && isOnReallocationDialog) ||
                    Boolean(maintenanceStatus === 'canceled' &&
                        !isCorporateAccepted &&
                        !isSuggestionStopped &&
                        (isOnReallocationDialog || isOnReopenDialog)) ||
                    Boolean(maintenanceStatus === 'scheduled' && isOnReallocationDialog)) ||
            maintenanceStatus === 'requested') {
            this.initializeScheduleSuggestionsWithSuggestions();
        }
        else {
            this.addSuggestion();
        }
    };
    DialogSchedulingSuggestionsComponent.prototype.initializeScheduleSuggestionsWithSuggestions = function () {
        var _this = this;
        this.scheduleSuggestionsFormArray.controls.forEach(function (control) {
            var _a = control.value, date = _a.date, time = _a.time;
            _this.setScheduleSuggestionsFormArrayToSaved(_this.createScheduleSuggestionsFormGroup(date, time));
        });
    };
    DialogSchedulingSuggestionsComponent.prototype.createScheduleSuggestionsFormGroup = function (date, time) {
        var newScheduleSuggestionFormGroup = new FormGroup({
            date: new FormControl(date, [Validators.required, DateValidation.validate]),
            time: new FormControl(time)
        }, {
            validators: [this.retroativeTimeValidator.bind(this), this.validateDuplicateValues.bind(this)]
        });
        if ((this.form.get('companyScheduleSuggestion') &&
            this.form.get('companyScheduleSuggestion').value) &&
            (!this.form.get('newCompany') &&
                this.form.get('status') &&
                this.form.get('status').value === 'onNegotiation')) {
            var existingValidators = newScheduleSuggestionFormGroup.validator;
            var companyAlreadySuggestedValidator = this.companyAlreadySuggestedValidator.bind(this);
            var combinedValidators = Validators.compose([existingValidators, companyAlreadySuggestedValidator]);
            newScheduleSuggestionFormGroup.setValidators(combinedValidators);
            newScheduleSuggestionFormGroup.updateValueAndValidity();
        }
        return newScheduleSuggestionFormGroup;
    };
    DialogSchedulingSuggestionsComponent.prototype.setScheduleSuggestionsFormArrayToSaved = function (scheduleSuggestion) {
        var _this = this;
        this.scheduleSuggestionsFormArrayToSaved.push(scheduleSuggestion);
        scheduleSuggestion.valueChanges.subscribe(function () {
            _this.updateStatusFromAllScheduleSuggestions();
        });
        this.updateStatusFromAllScheduleSuggestions();
    };
    DialogSchedulingSuggestionsComponent.prototype.updateStatusFromAllScheduleSuggestions = function () {
        var _this = this;
        var hasErrorMessage = false;
        this.scheduleSuggestionsFormArrayToSaved.controls.forEach(function (formGroup) {
            formGroup.updateValueAndValidity({ onlySelf: true, emitEvent: false });
            var errorMessage = _this.firstErrorPipe.transform(formGroup);
            formGroup['errorMessage'] = errorMessage;
            if (formGroup['errorMessage']) {
                hasErrorMessage = true;
            }
        });
        if (hasErrorMessage) {
            this.scheduleSuggestionsFormArrayToSaved.setErrors({ 'hasErrorMessage': true });
        }
        else {
            this.scheduleSuggestionsFormArrayToSaved.setErrors(null);
        }
    };
    DialogSchedulingSuggestionsComponent.prototype.retroativeTimeValidator = function (formGroup) {
        var currentDate = moment();
        var dateString = moment(formGroup.get('date').value).format('YYYY-MM-DD');
        var time = formGroup.get('time').value;
        var selectedDateTime = moment(dateString + " " + time, 'YYYY-MM-DD HH:mm');
        var isDateToday = dateString === moment(currentDate).format('YYYY-MM-DD');
        if (isDateToday && !time) {
            return null;
        }
        if (selectedDateTime.isBefore(currentDate)) {
            return {
                timeOutOfRange: true
            };
        }
        return null;
    };
    DialogSchedulingSuggestionsComponent.prototype.validateDuplicateValues = function (formGroup) {
        var formArray = this.scheduleSuggestionsFormArrayToSaved;
        for (var i = 0; i < formArray.length; i++) {
            var currentFormGroup = formArray.at(i);
            if (currentFormGroup === formGroup) {
                continue;
            }
            if (isEqual(currentFormGroup.value, formGroup.value)) {
                return {
                    equalSchedulingSuggestion: true
                };
            }
        }
        return null;
    };
    DialogSchedulingSuggestionsComponent.prototype.companyAlreadySuggestedValidator = function (formGroup) {
        var dateControl = formGroup.get('date');
        var timeControl = formGroup.get('time');
        var inputTime = moment(timeControl.value, 'HH:mm');
        var inputDate = moment(dateControl.value, 'YYYY-MM-DD');
        var companyScheduleSuggestionDate = moment(this.form.get('companyScheduleSuggestion').value.date);
        var companyScheduleSuggestionTime = moment(this.form.get('companyScheduleSuggestion').value.time, 'HH:mm');
        if (inputDate.isSame(companyScheduleSuggestionDate) && inputTime.isSame(companyScheduleSuggestionTime)) {
            return {
                scheduleAlreadySuggested: true
            };
        }
        return null;
    };
    DialogSchedulingSuggestionsComponent.prototype.addSuggestion = function () {
        if (this.scheduleSuggestionsFormArrayToSaved.controls.length >= this.suggestedLimit) {
            return;
        }
        var scheduleSuggestionsFormGroup = this.createScheduleSuggestionsFormGroup();
        this.setScheduleSuggestionsFormArrayToSaved(scheduleSuggestionsFormGroup);
    };
    DialogSchedulingSuggestionsComponent.prototype.deleteSuggestion = function (scheduleSuggestionIndex) {
        this.scheduleSuggestionsFormArrayToSaved.removeAt(scheduleSuggestionIndex);
        this.updateStatusFromAllScheduleSuggestions();
    };
    DialogSchedulingSuggestionsComponent.prototype.saveSchedulingSuggestions = function () {
        var _this = this;
        this.updateStatusFromAllScheduleSuggestions();
        if (this.scheduleSuggestionsFormArrayToSaved.invalid) {
            return;
        }
        this.scheduleSuggestionsFormArray.clear();
        this.scheduleSuggestionsFormArrayToSaved.controls.forEach(function (scheduleSuggestionValueToSave) {
            _this.scheduleSuggestionsFormArray.push(scheduleSuggestionValueToSave);
            _this.form.get('scheduleSuggestionsStatus').setValue('newScheduleSuggestion');
        });
        this.matDialogRef.close(true);
    };
    DialogSchedulingSuggestionsComponent.prototype.closeDialog = function () {
        this.matDialogRef.close(true);
    };
    return DialogSchedulingSuggestionsComponent;
}());
export { DialogSchedulingSuggestionsComponent };
